import { PaginationResult } from 'types/paginationResult';
import axios from 'utils/axios';
import FirmwareFilter from 'types/filters/firmwareFilter';
import { Firmware } from 'types/firmware';
import { ZipFile } from 'types/zipFile';

export default class FirmwareService {
    async getFirmwares(firmwareFilter: FirmwareFilter): Promise<PaginationResult<Firmware>> {
        try {
            const body = {
                page: firmwareFilter.page,
                recordsPerPage: firmwareFilter.recordsPerPage,
                searchString: firmwareFilter.searchString,
                orderBy: firmwareFilter.orderBy,
                orderAscending: firmwareFilter.orderAscending
            };
            const result = await axios.post<PaginationResult<Firmware>>(`/GetFirmwares`, body);
            return result.data;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to fetch firmware list');
        }
    }

    async addFirmware(firmware: Firmware): Promise<boolean> {
        try {
            const ZipFile = {
                Bytes: Array.from(new Uint8Array(firmware.zipFile))
            };
            const response = await axios.post(`/AddFirmware`, {
                major: firmware.major,
                minor: firmware.minor,
                releaseDate: firmware.releaseDate,
                releaseNote: firmware.releaseNote,
                internal: firmware.internal,
                zipFile: ZipFile
            });
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to add firmware');
        }
    }

    async editFirmware(firmware: Firmware): Promise<boolean> {
        try {
            const ZipFile = {
                Bytes: Array.from(new Uint8Array(firmware.zipFile))
            };
            const response = await axios.post(`/EditFirmware`, {
                id: firmware.id,
                major: firmware.major,
                minor: firmware.minor,
                releaseDate: firmware.releaseDate,
                releaseNote: firmware.releaseNote,
                internal: firmware.internal,
                zipFile: ZipFile
            });
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to edit firmware');
        }
    }

    async promoteFirmware(firmwareId: string): Promise<boolean> {
        try {
            const response = await axios.post(`/PromoteFirmware`, firmwareId);
            if (response.status >= 200 && response.status < 300) {
                return true;
            }
            return false;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to promote firmware');
        }
    }

    async downloadFirmware(fileName: string): Promise<ZipFile | null> {
        try {
            const response = await axios.post<ZipFile>(`/DownloadFirmware`, JSON.stringify(fileName), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status >= 200 && response.status < 300) {
                return response.data;
            }
            return null;
        } catch (error: any) {
            return Promise.reject((error.response && error.response.data) || 'Failed to download firmware');
        }
    }
}
